import { render, staticRenderFns } from "./SortSelect.vue?vue&type=template&id=6ebf34a8&scoped=true&"
import script from "./SortSelect.vue?vue&type=script&lang=ts&"
export * from "./SortSelect.vue?vue&type=script&lang=ts&"
import style0 from "./SortSelect.vue?vue&type=style&index=0&id=6ebf34a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebf34a8",
  null
  
)

export default component.exports